import { render } from "./TermsFrame.vue?vue&type=template&id=9f7afbb0&scoped=true"
import script from "./TermsFrame.vue?vue&type=script&lang=js"
export * from "./TermsFrame.vue?vue&type=script&lang=js"

import "./TermsFrame.vue?vue&type=style&index=0&id=9f7afbb0&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f7afbb0"]])

export default __exports__